import { toast } from "react-toastify";

export type HubSpotHelpChatTopic =
  | "generic"
  | "accounts"
  | "plans"
  | "approvals"
  | "onboarding"
  | "upsell";

function waitForHubSpotReady(
  callback: () => void,
  maxWaitTimeMs: number = 10_000
) {
  const startTime = Date.now();

  const checkReady = () => {
    try {
      // Check if HubSpot Conversations is ready
      if (
        window.HubSpotConversations &&
        window.HubSpotConversations.widget &&
        typeof window.HubSpotConversations.widget.open === "function"
      ) {
        callback();
        return;
      }
    } catch (error) {
      console.debug("HubSpot not yet ready:", error);
    }

    if (Date.now() - startTime > maxWaitTimeMs) {
      console.error("HubSpot widget failed to load within timeout period");

      return;
    }

    // Try again in 100ms
    setTimeout(checkReady, 100);
  };

  checkReady();
}

export function openSupportChat(
  message = "",
  helpChatTopic: HubSpotHelpChatTopic = "generic"
) {
  console.log("Opening HubSpot support chat", {
    message,
    query: helpChatTopic,
  });

  try {
    const searchParams = new URLSearchParams(window.location.search);
    const currentQuery = searchParams.get("hs-sked-chat");

    if (currentQuery === helpChatTopic) {
      waitForHubSpotReady(() => {
        window.HubSpotConversations.widget.open();
      });
      return;
    }

    // otherwise update the url param, refresh hubspot and then open it
    window.history.pushState({}, "", `?hs-sked-chat=${helpChatTopic}`);

    waitForHubSpotReady(() => {
      window.HubSpotConversations.widget.refresh({ openToNewThread: true });

      // Wait for the refresh to complete before opening
      waitForHubSpotReady(() => {
        window.HubSpotConversations.widget.open();
      }, 5000);
    });
  } catch (error) {
    console.error("Error opening HubSpot chat:", error);
    toast.error(
      "There was a problem opening live chat (please check your ad blocker is disabled). Please click the chat icon in the corner or email hi@skedsocial.com."
    );
  }
}
